import { useSelector } from 'react-redux';
import { CONFIG_PERMISSIONS } from '../constants/ConfigPermission';
import { RootState } from '../models/RootState';
import { useEffect, useState } from 'react';

export const isCasinoEnabled = (casinoEnabled: boolean, allowedConfig: number) => {
  return casinoEnabled && (allowedConfig & CONFIG_PERMISSIONS.casino) !== 0;
};

export const isSportsEnabled = (sportsEnabled: boolean, allowedConfig: number) => {
  return sportsEnabled && (allowedConfig & CONFIG_PERMISSIONS.sports) !== 0;
};

export const useDomainConfigHook = (): {
  showSportsComponents: boolean;
  showCasinoComponents: boolean;
} => {
  const { allowedConfig, domainConfig } = useSelector(
    (state: RootState) => state.common
  );

  const [sportsEnabled, setSportsEnabled] = useState(domainConfig?.sportsEnabled);
  const [casinoEnabled, setCasinoEnabled] = useState(domainConfig?.casinoEnabled);

  useEffect(() => {
    setSportsEnabled(domainConfig?.sportsEnabled);
    setCasinoEnabled(domainConfig?.casinoEnabled);
  }, [domainConfig]);

  const showSportsComponents = isSportsEnabled(sportsEnabled, allowedConfig);
  const showCasinoComponents = isCasinoEnabled(casinoEnabled, allowedConfig);

  return { showSportsComponents, showCasinoComponents };
};
